/// <amd-module name="Dashboards/DashboardView/src/components/ErrorMessageBar" />
import * as React from "react";

import * as Resources from "Dashboards/DashboardView/Resources";

import { FormatComponent } from "VSS/Platform/Components/Format";

import { Link } from "VSSUI/Link";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";

interface ErrorMessageBarProps {
    message: string;
    showRefreshLink?: boolean;
    onDismiss?: () => void;
}

/** A message bar for displaying errors on a dashboard. */
export class ErrorMessageBar extends React.PureComponent<ErrorMessageBarProps> {
    public render(): JSX.Element {
        return (
            <MessageBar className="dashboard-error-message-bar" onDismiss={this.props.onDismiss} severity={MessageBarSeverity.Error}>
                {!this.props.showRefreshLink && this.props.message}
                {this.props.showRefreshLink && (
                    <FormatComponent format={Resources.Error_RefreshFormat}>
                        {this.props.message}
                        <Link href={window.location.href}>{Resources.Error_Refresh}</Link>
                    </FormatComponent>
                )}
            </MessageBar>
        );
    }
}
